export default class ComplaintAuthPolicies {
    public changeToFormal = false;
    public reOpen = false;
    public changeReceivedDate = false;
    public changeResponsiblePerson = false;
    public seePromoterScore = false;
    public export = false;
}
